import "shared/ui/topbar/topbar.css";

import { apm } from "@elastic/apm-rum";
import { Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { topbarStore } from "shared/common/stores/topbarStore";
import MenuWithPointerForwarding from "shared/ui/muiComponentWrappers/MenuWithPointerForwarding";

export default function LanguageSelector() {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const anchorLang = topbarStore((state) => state.anchorLang);
  const changeAnchorLang = topbarStore((state) => state.changeAnchorLang);

  const LanguageId = "Language";
  const isLanguageOpen = Boolean(anchorLang);

  const { t, i18n } = useTranslation();

  //close modal of changing language
  const handleLanguageClose = () => {
    changeAnchorLang(null);
  };

  return (
    <MenuWithPointerForwarding
      anchorEl={anchorLang}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={LanguageId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        padding: 0,
        marginTop: "6px",
      }}
      open={isLanguageOpen}
      onClose={handleLanguageClose}
      classes={{
        root: "indexForLanguage",
        list: darkTheme ? "infra3d-menuListDark" : "infra3d-menuListLight",
      }}
    >
      <MenuItem
        sx={{
          gap: "10px",
          color: i18n.language.includes("de")
            ? "secondary.main"
            : darkTheme
              ? "white"
              : "darkblue.main",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
        onClick={() =>
          monitor(apm, "set-language-de | Language", () => {
            i18n.changeLanguage("de");
            handleLanguageClose();
          })
        }
      >
        <Typography variant="body1" fontWeight={700}>
          DE
        </Typography>
        <Typography variant="body1">{t("language.de")}</Typography>
      </MenuItem>
      <MenuItem
        sx={{
          gap: "10px",
          color: i18n.language.includes("en")
            ? "secondary.main"
            : darkTheme
              ? "white"
              : "darkblue.main",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
        onClick={() =>
          monitor(apm, "set-language-en | Language", () => {
            i18n.changeLanguage("en");
            handleLanguageClose();
          })
        }
      >
        <Typography variant="body1" fontWeight={700}>
          EN
        </Typography>
        <Typography variant="body1">{t("language.en")}</Typography>
      </MenuItem>
      <MenuItem
        sx={{
          gap: "10px",
          color: i18n.language.includes("fr")
            ? "secondary.main"
            : darkTheme
              ? "white"
              : "darkblue.main",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
        onClick={() =>
          monitor(apm, "set-language-fr | Language", () => {
            i18n.changeLanguage("fr");
            handleLanguageClose();
          })
        }
      >
        <Typography variant="body1" fontWeight={700}>
          FR
        </Typography>
        <Typography variant="body1">{t("language.fr")}</Typography>
      </MenuItem>
    </MenuWithPointerForwarding>
  );
}
